/*
 * @Description: 路由
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-25 13:30:09
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-10-28 15:25:04
 */
import { pages } from '@/config'

import {
  initRoutesMeta,
  getNavMenuConfig,
  downToUpReduceMetaAuthority,
} from '@/utils/router'

const HomeLayout = () => import(/* webpackChunkName: "home" */ '@/layout/HomeLayout.vue')
const HomePage = () => import(/* webpackChunkName: "home" */ '@/views/HomePage')

const LoginPage = () => import(/* webpackChunkName: "login" */ '@/views/LoginPage')
const DeptMana = () => import(/* webpackChunkName: "DeptMana" */ '@/views/DeptMana')
const RoleMana = () => import(/* webpackChunkName: "RoleMana" */ '@/views/RoleMana')
const UserMana = () => import(/* webpackChunkName: "UserMana" */ '@/views/UserMana')
const PlatformMana = () => import(/* webpackChunkName: "PlatformMana" */ '@/views/PlatformMana')
const ResourcesMana = () => import(/* webpackChunkName: "ResourcesMana" */ '@/views/ResourcesMana')
const ResourceDefinition = () => import(/* webpackChunkName: "ResourceDefinition" */ '@/views/ResourceDefinition')
// const AuthorityMana = () => import(/* webpackChunkName: "authorityMana" */ '@/views/AuthorityMana')
const ModuleMana = () => import(/* webpackChunkName: "ModuleMana" */ '@/views/ModuleMana')

const NoFind = () => import(/* webpackChunkName: "404" */ '@/views/Exception/404.vue')
const NoPermission = () => import(/* webpackChunkName: "403" */ '@/views/Exception/403.vue')

const routes = [
  {
    path: '/',
    component: HomeLayout,
    meta: { hideInMenu: true },
    redirect: 'userMana',
    children: [
      {
        path: 'home',
        alias: pages.home.name,
        redirect: 'userMana',
        name: pages.home.name,
        component: HomePage,
        meta: {
          name: '首页',
          title: '首页',
          icon: pages.home.name,
          hideInMenu: true,
          authority: true,
        },
      },
    ],
  },
  {
    path: pages.login.path,
    name: pages.login.name,
    component: LoginPage,
    meta: {
      title: '登录页面',
      hideInMenu: true,
      // authority: true,
    },
  },
  {
    path: '/',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: 'userMana',
        name: 'userMana',
        component: UserMana,
        meta: {
          name: '用户管理',
          title: '用户管理',
          icon: pages.home.name,
          authority: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: 'deptMana',
        name: 'deptMana',
        component: DeptMana,
        meta: {
          name: '部门管理',
          title: '部门管理',
          icon: pages.home.name,
          authority: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: 'platformMana',
        name: 'platformMana',
        component: PlatformMana,
        meta: {
          name: '平台管理',
          title: '平台管理',
          icon: pages.home.name,
          authority: true,
        },
      },
    ],
  },
  {
    path: '/authorityMana',
    component: HomeLayout,
    meta: {
      hideInMenu: false,
      name: '权限管理',
      title: '权限管理',
      icon: pages.home.name,
    },
    children: [
      {
        path: 'roleMana',
        name: 'roleMana',
        component: RoleMana,
        meta: {
          name: '角色管理',
          title: '角色管理',
          icon: pages.home.name,
          authority: true,
        },
      },
      {
        path: 'moduleMana',
        name: 'moduleMana',
        component: ModuleMana,
        meta: {
          name: '模块管理',
          title: '模块管理',
          icon: pages.home.name,
          authority: true,
        },
      },
      {
        path: 'resourcesMana',
        name: 'resourcesMana',
        component: ResourcesMana,
        meta: {
          name: '资源管理',
          title: '资源管理',
          icon: pages.home.name,
          authority: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: 'resourceDefinition',
        name: 'resourceDefinition',
        component: ResourceDefinition,
        meta: {
          name: '资源定义',
          title: '资源定义',
          icon: pages.home.name,
          authority: true,
        },
      },
    ],
  },
  {
    path: '/',
    redirect: pages.home.path,
    meta: { hideInMenu: true },
  },
  {
    path: '/403',
    component: NoPermission,
    meta: { hideInMenu: true, title: '你没有权限访问该页面' },
  },
  {
    path: '*',
    component: NoFind,
    meta: { hideInMenu: true, title: '没有找到你要去的页面' },
  },
]

const reduceRoute = downToUpReduceMetaAuthority(initRoutesMeta(routes))

export const navMenuConfig = getNavMenuConfig(reduceRoute)

export default reduceRoute
